import { DocSignatureType } from "../../models/document-signature-type";

export const docSignatureTypes: DocSignatureType[] = [
  {
    attendance: false,
    attendanceComment: false,
    comments: false,
    consent: true,
    dates: false,
    icon: 'fa-solid fa-map-pin',
    id: 'pdf-dryneedle-consent',
    name: 'pdf-dryneedle-consent',
    patientInfo: false,
    signatures: 2,
    url: 'pdf-sample/consent+dry_needle',
  },
  {
    attendance: false,
    attendanceComment: false,
    comments: false,
    consent: true,
    dates: false,
    icon: 'fa-solid fa-bolt-lightning',
    id: 'pdf-epi-consent',
    name: 'pdf-epi-consent',
    patientInfo: false,
    signatures: 2,
    url: 'pdf-sample/consent+epi',
  },
  {
    attendance: false,
    attendanceComment: false,
    comments: true,
    consent: true,
    dates: false,
    icon: 'fa-solid fa-droplet',
    id: 'pdf-prp-consent',
    name: 'pdf-prp-consent',
    patientInfo: false,
    signatures: 2,
    url: 'pdf-sample/consent+prp',
  },
  {
    attendance: false,
    attendanceComment: false,
    comments: false,
    consent: false,
    dates: false,
    icon: 'pi pi-user',
    id: 'pdf-rgpd',
    name: 'pdf-rgpd',
    patientInfo: false,
    signatures: 1,
    url: 'pdf-sample/rgpd',
  },
  {
    attendance: true,
    attendanceComment: true,
    comments: false,
    consent: false,
    dates: true,
    icon: 'pi pi-file',
    id: 'pdf-attendance',
    name: 'pdf-attendance',
    patientInfo: false,
    signatures: 0,
    url: '',
  },
];